module.exports = __webpack_public_path__ + "media/img/logo-e6a28e2626c2405241250095466de4bb.png";